import { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuthSelector } from '@providers/AuthProvider/ui/AuthProvider';
import {
  adminLandingPath,
  canOpenAdminArea,
} from '@pages/SuperAdminPanelPage/access';

/**
 * Lets super admins and firm accounts into the admin area and sends everyone
 * else to /home (ZLAYT-1241). Which tabs a firm account may open inside it is
 * decided per route.
 */
export const AdminAreaRoute: FC<PropsWithChildren> = ({ children }) => {
  const userData = useAuthSelector((state) => state.userData);
  const loading = useAuthSelector((state) => state.loading);

  // Render nothing until the session is known, so admin content never flashes.
  if (loading) {
    return null;
  }

  if (!canOpenAdminArea(userData)) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};

/** /admin on its own: the first tab this user may open. */
export const AdminIndexRedirect: FC = () => {
  const userData = useAuthSelector((state) => state.userData);
  return <Navigate replace to={adminLandingPath(userData)} />;
};
